export const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Esto añade un efecto de desplazamiento suave
    });
  };